module.exports = __webpack_public_path__ + "img/smartphone.752b1833.svg";